import { useEffect, useState } from 'react';

// There is a known bug in argonaut that causes analytics events after redirect to not fire
// See: https://rea-group.slack.com/archives/C017U2NB22W/p1722473140477829
// This hook is a workaround to wait for hydration before firing analytics events
// This hook should be removed once the argonaut issue is resolved, it should not be used for any other purpose

const useWaitForHydrationWorkaround = (): boolean => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return isHydrated;
};

export { useWaitForHydrationWorkaround };
